export default __webpack_public_path__ + "static/media/Youth_Illustrations-CIHR Logo.3070f053.svg";